exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.red-txt {\n    color: red;\n}\n.text-small {\n    font-size: 18px;\n}\n", ""]);

// exports
